<!-- Template code MUST be disabled: https://github.com/apertureless/vue-chartjs#single-file-components -->
<!--<template>-->
    <!---->
<!--</template>-->

<script>
import { Bar } from 'vue-chartjs';

export default {
    name: 'api-calls-bar',
    extends: Bar,
    props: ['labels', 'dataClientApi', 'dataServiceApi'],
    mounted() {
        this.renderData(this.labels, this.dataClientApi, this.dataServiceApi);
    },
    watch: {
        labels: function(newVal, oldVal) {
            this.renderData(this.labels, this.dataClientApi, this.dataServiceApi);
        },
        dataClientApi: function(newVal, oldVal) {
            this.renderData(this.labels, this.dataClientApi, this.dataServiceApi);
        },
        dataServiceApi: function(newVal, oldVal) {
            this.renderData(this.labels, this.dataClientApi, this.dataServiceApi);
        }
    },
    methods: {
        renderData: function(labels, dataClientApi, dataServiceApi) {
            this.renderChart({
                labels: labels,
                datasets: [
                    {
                        label: 'Client API',
                        backgroundColor: '#52D160',
                        data: dataClientApi
                    },
                    {
                        label: 'Service API',
                        backgroundColor: '#46597D',
                        data: dataServiceApi
                    }
                ]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 20,
                        right: 50,
                        top: 20,
                        bottom: 20
                    }
                }
            });
        }
    }
};
</script>

<style scoped>

</style>